import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { SectionModal, SectionTitle, Ticket, HSpacer, AnchorButton, colors, ticketType, TextDescription, ExpandLink } from '@aftersale-next/ui';
import { useTranslation } from 'react-i18next';
import { useCouponAfterDelivered } from '../../hooks/use-coupon-after-delivered';
import { copyToClipboard } from '@aftersale-next/utils';
export function CouponAfterDelivered() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useCouponAfterDelive = useCouponAfterDelivered(),
      value = _useCouponAfterDelive.value,
      rules = _useCouponAfterDelive.rules,
      enabled = _useCouponAfterDelive.enabled,
      redirectLink = _useCouponAfterDelive.redirectLink;

  if (!enabled) return null;
  return /*#__PURE__*/_jsxs(SectionModal, {
    children: [/*#__PURE__*/_jsx(SectionTitle, {
      children: t('COUPON_OFFER')
    }), /*#__PURE__*/_jsx(HSpacer, {}), /*#__PURE__*/_jsx(TextDescription, {
      children: t('COUPON_DESCRIPTION')
    }), /*#__PURE__*/_jsx(HSpacer, {}), /*#__PURE__*/_jsx(HSpacer, {}), /*#__PURE__*/_jsx(Ticket, {
      type: ticketType.TICKET_COUPON,
      value: value
    }), /*#__PURE__*/_jsx(HSpacer, {}), /*#__PURE__*/_jsx(HSpacer, {}), /*#__PURE__*/_jsx(AnchorButton, {
      redirectLink: redirectLink,
      isExternal: true,
      onClick: function onClick() {
        return copyToClipboard(value);
      },
      id: "coupon-copy-redirect-button",
      bgColor: colors.green,
      children: t('COPY_AND_GO_SHOP')
    }), /*#__PURE__*/_jsx(ExpandLink, {
      title: t('COUPON_RULES_TITLE'),
      expandableText: rules
    })]
  });
}